const ReportPanelSVG = require("./report.panel.svg").default;

export { ReportPanelSVG };
